import $ from 'jquery';

const aktivPropertySearchApiUrl = '/api/AktivPropertySearch';

const autoCompleteSearch = (searchTerm) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${aktivPropertySearchApiUrl}/AutoCompleteSearch`,
      dataType: 'json',
      data: {
        term: searchTerm,
      },
      success: (data) => {
        const hits = data.map((hit) => {
          return hit;
        });
        resolve(hits);
      },
      error: () => {
        reject();
      },
    });
  });
};

const propertySearch = (searchTerm, index, pageSize) => {
  return $.ajax({
    url: `${aktivPropertySearchApiUrl}/propertysearch`,
    dataType: 'json',
    method: 'POST',
    data: { propertySearch: searchTerm, index, pageSize },
  });
};

const locationSearch = (searchTerm) => {
  return $.ajax({
    url: `${aktivPropertySearchApiUrl}/locationsearch`,
    dataType: 'json',
    data: searchTerm,
  });
};

const getCounties = () => {
  return $.ajax({
    url: `${aktivPropertySearchApiUrl}/counties`,
    dataType: 'json',
  });
};

const getMunicipalities = (countyId) => {
  return $.ajax({
    url: `${aktivPropertySearchApiUrl}/municipalities`,
    dataType: 'json',
    data: {
      countyId,
    },
  });
};

const getCityAreas = (municipalityId) => {
  return $.ajax({
    url: `${aktivPropertySearchApiUrl}/cityareas`,
    dataType: 'json',
    data: {
      municipalityId,
    },
  });
};

export { autoCompleteSearch };
export { propertySearch };
export { locationSearch };
export { getCounties };
export { getMunicipalities };
export { getCityAreas };
